import { achatarEventos } from "../../main/services/AuditoriaService";

export function agruparEventosRelatorioAuditoria(eventos) {
  const linhas = achatarEventos(eventos);
  const grupos = [];
  const gruposPorAba = new Map();

  linhas.forEach((linha) => {
    const nomeAba = linha.aba || "Outros";
    let grupoAba = gruposPorAba.get(nomeAba);
    if (!grupoAba) {
      grupoAba = { aba: nomeAba, camposPorNome: new Map(), campos: [] };
      gruposPorAba.set(nomeAba, grupoAba);
      grupos.push(grupoAba);
    }

    const nomeCampo = linha.campoExibicao || linha.campo || "Outros";
    let grupoCampo = grupoAba.camposPorNome.get(nomeCampo);
    if (!grupoCampo) {
      grupoCampo = { campo: nomeCampo, linhas: [] };
      grupoAba.camposPorNome.set(nomeCampo, grupoCampo);
      grupoAba.campos.push(grupoCampo);
    }

    grupoCampo.linhas.push({ ...linha, numero: grupoCampo.linhas.length + 1 });
  });

  return grupos.map(({ aba, campos }) => ({ aba, campos }));
}
